import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVendorAuth } from '../contexts/VendorAuthContext';

interface UseOnboardingAuthOptions {
  currentStep: number;
  redirectIfPasswordNeeded?: boolean;
}

export const useOnboardingAuth = ({ 
  currentStep, 
  redirectIfPasswordNeeded = true 
}: UseOnboardingAuthOptions) => {
  const navigate = useNavigate();
  const { vendor, isLoading } = useVendorAuth();

  useEffect(() => {
    // Only redirect if vendor needs password setup
    if (vendor && redirectIfPasswordNeeded && vendor.needsPasswordSetup) {
      navigate('/onboarding/step1', { replace: true });
      return;
    }

    // No other automatic redirects - let users navigate freely between onboarding steps
  }, [vendor, navigate, redirectIfPasswordNeeded]);

  return {
    vendor,
    isLoading,
    isAuthenticated: !!vendor
  };
};
